import { useMemo } from 'react';

import { useHideEmployeeCommissions } from 'hooks';
import { EventDashboard } from 'components/event-dashboard';
import { isEventNotStarted } from 'components/event-dashboard/helpers';

import { DashboardProps } from './types';
import { getInitialDateRange } from './helpers';

export const Dashboard = ({ id, event }: DashboardProps) => {
  const hideEmployeeCommissions = useHideEmployeeCommissions();
  const initialDateRange = useMemo(() => getInitialDateRange(event), [event]);
  const eventNotStarted = isEventNotStarted(event?.startDate);

  return (
    <EventDashboard
      id={id}
      withoutPadding
      withDateRangeRestriction
      initDateRange={initialDateRange}
      eventNotStarted={eventNotStarted}
      datePickerContainerPadding="0 0 16px"
      hideEmployeeCommissions={hideEmployeeCommissions}
    />
  );
};
